/*
 * tg-kids-cta
 *
 * Upgrades the CTA anchor to an offset smooth scroll.
 *
 * Why this exists: the button's href is a real anchor to #product--section, so
 * it works with JS disabled. But a raw anchor jump puts the target at viewport
 * top, underneath the theme's sticky header and sticky ATC bar, so the shopper
 * lands mid buy box with the pack selector already scrolled past.
 *
 * The obvious fix is `#product--section { scroll-margin-top: Npx }`, which is
 * deliberately NOT used: #product--section is owned by sections/ecom-product
 * .liquid and is shared with the live theme. assets/tg-kids-claude-difference
 * .css documents the same decision. Instead the sticky bar height is measured
 * at runtime here, so nothing outside this section is touched and the offset
 * stays correct if the header height ever changes.
 *
 * Custom element rather than an IIFE so connectedCallback re-runs after a
 * Shopify theme-editor section reload.
 */
if (!customElements.get("tg-kids-cta")) {
  customElements.define(
    "tg-kids-cta",
    class TgKidsCta extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === "true") return;
        this.dataset.ready = "true";

        this.link = this.querySelector("[data-tgcta-scroll]");
        if (!this.link) return;

        this.onClick = this.onClick.bind(this);
        this.link.addEventListener("click", this.onClick);
      }

      disconnectedCallback() {
        if (this.link) this.link.removeEventListener("click", this.onClick);
      }

      /*
       * Sum of anything pinned to the top of the viewport. Elements are only
       * counted when they are actually at the top (<= 4px) and are plausibly a
       * bar rather than a full-screen overlay (< 200px tall), so a sticky
       * sidebar or an open modal does not inflate the offset.
       */
      stickyOffset() {
        var max = 0;
        var nodes = document.body.querySelectorAll("*");

        for (var i = 0; i < nodes.length; i++) {
          var el = nodes[i];
          var pos = getComputedStyle(el).position;
          if (pos !== "fixed" && pos !== "sticky") continue;

          var r = el.getBoundingClientRect();
          if (r.height <= 0 || r.height >= 200) continue;
          if (r.top > 4 || r.bottom <= 0) continue;
          if (r.bottom > max) max = r.bottom;
        }

        return max;
      }

      onClick(event) {
        var selector = this.link.getAttribute("href");
        if (!selector || selector.charAt(0) !== "#") return;

        var target = document.querySelector(selector);
        if (!target) return; // let the browser handle it / do nothing

        event.preventDefault();

        var extra = parseInt(this.dataset.scrollExtra, 10);
        if (isNaN(extra)) extra = 16;

        var top =
          target.getBoundingClientRect().top +
          window.pageYOffset -
          this.stickyOffset() -
          extra;

        if (top < 0) top = 0;

        var reduce =
          window.matchMedia &&
          window.matchMedia("(prefers-reduced-motion: reduce)").matches;

        window.scrollTo({ top: top, behavior: reduce ? "auto" : "smooth" });
      }
    },
  );
}
